export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';

export const changeCurrency = currency => ({ type: CHANGE_CURRENCY, payload: currency });
